import React from 'react';
import {
  LayoutDashboard,
  Upload,
  Target,
  MessageSquare,
  BarChart2,
  Users,
  User,
  Zap,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface NavItem {
  label: string;
  icon: React.ReactNode;
  href: string;
}

const navItems: NavItem[] = [
  { label: 'Dashboard', icon: <LayoutDashboard size={16} />, href: '/dashboard' },
  { label: 'Análise de Mãos', icon: <Upload size={16} />, href: '/sessions' },
  { label: 'Treinos', icon: <Target size={16} />, href: '/treinos' },
  { label: 'IA Coach', icon: <MessageSquare size={16} />, href: '/coach' },
  { label: 'Estatísticas', icon: <BarChart2 size={16} />, href: '/stats' },
  { label: 'Comunidade', icon: <Users size={16} />, href: '/comunidade' },
  { label: 'Meu Perfil', icon: <User size={16} />, href: '/profile' },
];

interface SidebarProps {
  activeRoute: string;
}

export default function Sidebar({ activeRoute }: SidebarProps) {
  const { user } = useAuth();

  return (
    <aside
      style={{
        width: 220,
        minWidth: 220,
        background: '#111111',
        borderRight: '1px solid rgba(255,255,255,0.07)',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 10,
        overflowY: 'auto',
        fontFamily: 'Inter, sans-serif',
      }}
    >
      {/* Logo */}
      <div style={{ padding: '28px 20px 24px' }}>
        <span
          style={{
            color: '#ffffff',
            fontWeight: 800,
            fontSize: 16,
            letterSpacing: '-0.3px',
          }}
        >
          POKERMIND ♠
        </span>
        <div
          style={{
            color: '#00e676',
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.15em',
            marginTop: 3,
          }}
        >
          BRASIL
        </div>
      </div>

      {/* MENU label */}
      <div style={{ padding: '0 20px 8px' }}>
        <span
          style={{
            color: '#555555',
            fontSize: 10,
            fontWeight: 500,
            letterSpacing: '0.8px',
            textTransform: 'uppercase',
          }}
        >
          MENU
        </span>
      </div>

      {/* Nav items */}
      <nav style={{ flex: 1, padding: '0 10px' }}>
        {navItems.map((item) => {
          const isActive = activeRoute === item.href;
          return (
            <Link
              key={item.href}
              to={item.href}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '10px 12px',
                borderRadius: 8,
                marginBottom: 2,
                textDecoration: 'none',
                color: isActive ? '#00e676' : '#a0a0a0',
                background: isActive ? 'rgba(0,230,118,0.08)' : 'transparent',
                borderLeft: isActive ? '2px solid #00e676' : '2px solid transparent',
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(255,255,255,0.04)';
                  (e.currentTarget as HTMLAnchorElement).style.color = '#ffffff';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  (e.currentTarget as HTMLAnchorElement).style.background = 'transparent';
                  (e.currentTarget as HTMLAnchorElement).style.color = '#a0a0a0';
                }
              }}
            >
              <span style={{ display: 'flex', color: isActive ? '#00e676' : 'inherit' }}>
                {item.icon}
              </span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Upgrade card */}
      {user?.plan === 'free' && (
        <div style={{ padding: '12px 12px 20px' }}>
          <div
            style={{
              background: 'rgba(0,230,118,0.04)',
              border: '1px solid rgba(0,230,118,0.12)',
              borderRadius: 8,
              padding: 14,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 8,
              }}
            >
              <Zap size={13} color="#00e676" />
              <span
                style={{
                  color: '#ffffff',
                  fontSize: 13,
                  fontWeight: 700,
                }}
              >
                Upgrade para Pro
              </span>
            </div>
            <p
              style={{
                color: '#a0a0a0',
                fontSize: 12,
                marginBottom: 12,
                lineHeight: 1.5,
              }}
            >
              Acesso ilimitado à IA Coach e análises avançadas
            </p>
            <a
              href="https://pay.kiwify.com.br/Ad3EqAb"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'block',
                background: 'transparent',
                border: '1px solid #00e676',
                color: '#00e676',
                textAlign: 'center',
                padding: '8px 0',
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 700,
                textDecoration: 'none',
                transition: 'background 0.15s',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(0,230,118,0.08)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLAnchorElement).style.background = 'transparent';
              }}
            >
              Ver planos
            </a>
          </div>
        </div>
      )}
    </aside>
  );
}
